import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from '../../../lib/i18n';
import { useProductName } from '../../../lib/use-brand';
import { useInstallQrLink } from '../../../lib/use-install-qr-link';
import { StoreBadges } from '../catch-up/MobileAppCard';
import { Card, Typography } from '../ui';
import { HOME3_PAGE } from './Home3Feed';
import styles from './Home3MobileAppCard.module.css';

// "Download Symphony mobile app" at the top of the Overview home's rail (Figma 20325:122407) — the
// catch-up home's `MobileAppCard` in the rail's layout.
//
// No native counterpart, deliberately — see `MobileAppCard` and orion-web/CLAUDE.md.

const QR_SIZE = 92;

export function Home3MobileAppCard() {
  const { t } = useTranslation();
  const productName = useProductName();
  const qrLink = useInstallQrLink();

  return (
    <Card className={styles.card}>
      <div className={styles.row}>
        <div className={styles.text}>
          <Typography variant="display-05" color="primary" component="h2" className={styles.title}>
            {t('home.mobileApp.title', { productName })}
          </Typography>
          <Typography variant="heading-04" color="primary" component="p" className={styles.caption}>
            {t('home.mobileApp.caption')}
          </Typography>
        </div>
        {/* Black-on-white in BOTH themes — an inverted QR is refused by many scanners. In dark the
            card is dark, so `.qr` adds the white quiet zone the light card otherwise provides. */}
        <div className={styles.qr}>
          <QRCodeSVG
            value={qrLink}
            size={QR_SIZE}
            level="M"
            marginSize={0}
            bgColor="var(--ds-white)"
            fgColor="var(--ds-black)"
            title={t('home.mobileApp.qrAlt', { productName })}
          />
        </div>
      </div>
      <StoreBadges page={HOME3_PAGE} className={styles.badges} />
    </Card>
  );
}
